import React from "react";
import { useLanguage } from "../context/LanguageContext";

const roleMap = {
  admin: "bg-slate-100 text-slate-700 border-slate-200",
  agent: "bg-blue-50 text-blue-700 border-blue-100",
  reviewer: "bg-indigo-50 text-indigo-700 border-indigo-100",
};

const statusMap = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-100",
  pending_approval: "bg-amber-50 text-amber-700 border-amber-100",
  disabled: "bg-rose-50 text-rose-700 border-rose-100",
};

export const RoleBadge = ({ role }) => {
  const { t } = useLanguage();
  const cls = roleMap[role] || roleMap.agent;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${cls}`}
      data-testid={`role-badge-${role}`}
    >
      {t(`role_${role}`)}
    </span>
  );
};

export const StatusBadge = ({ status }) => {
  const { t } = useLanguage();
  const cls = statusMap[status] || statusMap.active;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${cls}`}
      data-testid={`status-badge-${status}`}
    >
      {t(`status_${status}`)}
    </span>
  );
};
